import { fetchAPI } from 'api';
import { SendTransaction } from './types';

export const getTransactionDetails = (transactionId: string) => {
  return fetchAPI<SendTransaction>(`v1/transactions/${transactionId}`);
};
